import React, { useEffect, useState } from 'react';
import './index.scss';
import {
    Button,
    Col,
    Divider,
    Tabs,
    Row,
    Typography,
    notification,
    Space,
    Form,
    Input, Upload, Spin, Select, Skeleton, InputNumber, Switch,
} from 'antd';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import {
    UploadOutlined,
    ArrowLeftOutlined,
} from '@ant-design/icons';
import CurriculumForm from './CurriculumForm';
import ContentsPage from '../Contents/ContentsPage';

const { TabPane } = Tabs;


interface Props {
    location: any;
}

const { Title } = Typography;
const { Option } = Select;
export default function CurriculumView(props: Props) {
    const { t } = useTranslation();
    const history: any = useHistory();
    const RouteParams: any = useParams();
    return (
        <div className={'list-page-wrapper'}>
            <Row gutter={30} justify={'space-between'} wrap={false}>
                <Col style={{ paddingTop: '10px' }}>
                    <Button type={'link'} onClick={() => history.goBack()} icon={<ArrowLeftOutlined/>}/>
                </Col>
                <Col flex={'auto'}>
                    <Tabs defaultActiveKey="1">
                        <TabPane tab={t('genDict.view')} key="1">
                            <CurriculumForm location={props.location} hideHeader={true}/>
                        </TabPane>
                        <TabPane tab={t('genDict.contents')} key="2">
                            <ContentsPage location={props.location}/>
                        </TabPane>
                    </Tabs>
                </Col>
            </Row>
        </div>
    );
}
